import { ErrorView } from "components/ErrorView/ErrorView";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const NoClientsPage = React.lazy(() => import("modules/GenericModule/pages/NoClientsPage/NoClientsPage"));
const MobilePage = React.lazy(() => import("modules/GenericModule/pages/MobilePage/MobilePage"));
const NotificationsRedirectPage = React.lazy(
  () => import("modules/GenericModule/pages/NotificationsRedirectPage/NotificationsRedirectPage"),
);
const GenericModule = React.lazy(() => import("modules/GenericModule/GenericModule"));

export const GenericModuleRoutes: RouteObject = {
  path: "/common",
  element: <PageRoute El={GenericModule} />,
  errorElement: <ErrorView />,
  children: [
    {
      path: "no-client-id",
      element: <PageRoute El={NoClientsPage} />,
    },
    {
      path: "mobile",
      element: <PageRoute El={MobilePage} />,
    },
    {
      path: "notification-redirect",
      element: <PageRoute El={NotificationsRedirectPage} />,
    },
  ],
};
